// Session-scoped value that binds a Vilnius Login / eVartai callback to the
// browser tab that initiated the login attempt. Held in sessionStorage so it
// dies with the tab and cannot be replayed by a separately initialized session.
const LOGIN_VERIFIER_KEY = 'login-verifier';

const createLoginVerifier = (): string => {
  const bytes = new Uint8Array(32);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join(
    '',
  );
};

export const storeLoginVerifier = (): string => {
  const verifier = createLoginVerifier();
  sessionStorage.setItem(LOGIN_VERIFIER_KEY, verifier);
  return verifier;
};

export const readLoginVerifier = (): string | null =>
  sessionStorage.getItem(LOGIN_VERIFIER_KEY);

export const clearLoginVerifier = (): void =>
  sessionStorage.removeItem(LOGIN_VERIFIER_KEY);
